export const FULL_REFUND = 'FULL_REFUND';
export const PARTIAL_REFUND = 'PARTIAL_REFUND';
export const STANDARD_REFUND = 'STANDARD_REFUND';
export const MONEY_REFUND = 'MONEY_REFUND';
export const REFUND_SERVICE_REFUND = 'REFUND_SERVICE_REFUND';
export const POS_REFUND = 'POS_REFUND';
export const WORLDPAY_EXPRESS = 'WORLDPAY_EXPRESS';
